import { render } from "./AdditionalActionComponent.vue?vue&type=template&id=0fd03130"
import script from "./AdditionalActionComponent.vue?vue&type=script&lang=js"
export * from "./AdditionalActionComponent.vue?vue&type=script&lang=js"

import "./AdditionalActionComponent.vue?vue&type=style&index=0&id=0fd03130&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__